import React from 'react'
import './TimeoutCountdownBar.css'

/**
 * Timeout countdown bar component that displays at the top of the page
 * Shows remaining time as a progress bar with countdown text
 */
const TimeoutCountdownBar = ({ remainingTime, totalTime, isVisible = true, isWarning = false, config = {} }) => {
    if (!isVisible || remainingTime <= 0) {
        return null
    }

    // Calculate progress percentage (0-100)
    const progressPercentage = Math.max(0, Math.min(100, (remainingTime / totalTime) * 100))

    // Format time display
    const formatTime = timeMs => {
        const totalSeconds = Math.floor(timeMs / 1000)
        const hours = Math.floor(totalSeconds / 3600)
        const minutes = Math.floor((totalSeconds % 3600) / 60)
        const seconds = totalSeconds % 60

        if (hours > 0) {
            return `${hours}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
        }
        return `${minutes}:${seconds.toString().padStart(2, '0')}`
    }

    // Determine bar color based on remaining time
    const getBarColor = () => {
        if (isWarning) return config.warningColor || '#ff6b35'
        if (progressPercentage <= 10) return config.criticalColor || '#dc3545'
        if (progressPercentage <= 25) return config.warningColor || '#ffc107'
        return config.normalColor || '#28a745'
    }

    // Determine text based on state
    const getText = () => {
        if (isWarning) {
            return config.warningText || 'Session expiring soon!'
        }
        return config.normalText || 'Session timeout:'
    }

    return (
        <div className={`timeout-countdown-bar ${isWarning ? 'warning' : ''}`}>
            <div className="countdown-content">
                <div className="countdown-text">
                    <span className="countdown-label">{getText()}</span>
                    <span className="countdown-time">{formatTime(remainingTime)}</span>
                </div>
            </div>

            <div className="progress-bar-container">
                <div
                    className="progress-bar"
                    style={{
                        width: `${progressPercentage}%`,
                        backgroundColor: getBarColor(),
                    }}
                />
            </div>
        </div>
    )
}

export default TimeoutCountdownBar
